import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-feature-checkbox',
  imports: [],
  templateUrl: './feature-checkbox.component.html',
  styleUrl: './feature-checkbox.component.scss',
})
export class FeatureCheckboxComponent {
  label = input.required<string>();
  checked = input<boolean>(false);
  disabled = input<boolean>(false);
  checkedChange = output<boolean>();

  onCheckboxChange(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    this.checkedChange.emit(checkbox.checked);
  }
}
